export const INVENTORY_SETTINGS_LINK = 'https://steamcommunity.com/id/me/edit/settings';

export const STEAM_TRADE_LINK = `https://steamcommunity.com/id/me/tradeoffers/privacy`;

export const STEAM_API_KEY_LINK = 'https://steamcommunity.com/dev/apikey';

export const STEAM_GUARD = `https://store.steampowered.com/mobile`;
